import {
    Badge,
    Box,
    Button,
    CopyButton,
    Group,
    Text,
    Tooltip,
    rem,
} from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';

import { pascalToFriendly } from '../../../../../utils/text';

const EventTypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Group gap={'xs'}>
                <Badge size='sm'>{pascalToFriendly(rowData.type)}</Badge>
                <CopyButton value={rowData.eventId}>
                    {({ copied, copy }) => (
                        <Tooltip label={'Copy ID'}>
                            <Button
                                size={'compact-xs'}
                                color={copied ? 'teal.6' : 'blue'}
                                onClick={copy}>
                                {copied ? (
                                    <IconCopyCheck
                                        style={{
                                            width: rem(10),
                                            height: rem(10),
                                        }}
                                        stroke={1.5}
                                    />
                                ) : (
                                    <IconCopy
                                        style={{
                                            width: rem(10),
                                            height: rem(10),
                                        }}
                                        stroke={1.5}
                                    />
                                )}
                            </Button>
                        </Tooltip>
                    )}
                </CopyButton>
            </Group>
        </Box>
    );
};

const TypeEventColumn = () => ({
    accessorKey: 'type',
    header: 'Type',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <EventTypeCell cell={cell} />,
});
export default TypeEventColumn;
